import Info from '@components/Info';
import Section from '@components/Section';
import Button from '@components/UI/Button';
import Container from '@components/UI/Container';
import useMods from '@hooks/useMods';
import useUtmTags, { Utm } from '@hooks/useUtmTags';

import css from '@utils/css';
import PropTypes from 'prop-types';

import React from 'react';


const CTABanner = ({
  title,
  subTitle = '',
  btnText = 'Check this out for yourself',
  btnLink = '',
  mods = {},
  className: classNameTail = ''
}) => {

  const { className } = useMods(CTABanner, { mods });

  return (
    <Section
      mods={{
        py: true,
        'no-margin': true
      }}
    >
      <Container>
        <div className={className + (classNameTail ? ' ' + classNameTail : '')}>
          <Info
            mods={{ center: true }}
            className={css('relative flex flex-col justify-center text-center p-8 md:p-12 xl:p-16')}
          >
            <div
              className='absolute left-0 top-0 bg-white h-full w-full overflow-hidden -z-[1] rounded-16p'
            >
              <div
                className='radials radials_dark radials_gradient_third w-[1716px] h-[1716px]'
              >
              </div>
              <div
                className='radials radials_dark w-[960px] h-[960px]'
              >
              </div>
              <div
                className='radials radials_dark radials_gradient_first w-[600px] h-[600px]'
              >
              </div>
            </div>
            <h2
              className='heading heading_white heading_banner h3'
            >
              {title}
            </h2>
            {subTitle && (
              <div
                className={"text-18p leading-[140%] 1024:text-24p 1024:leading-28p 1280:text-26p 1280:leading-32p text-white font-400"}
              >
                {subTitle}
              </div>
            )}
            <div className={css('flex flex-col gap-4 justify-center mt-5 max-sm:w-full')}>
              <Button
                tag='a'
                type='link'
                href={useUtmTags(btnLink || `${process.env.NEXT_PUBLIC_APP_TRAQQ_URL}/signup`,
                  {
                    utm_campaign: Utm.CAMPAIGN.BANNER,
                    utm_term: btnText
                  })}
                variant='primary'
                size='lg'
                mods={{ 'no-spacing': true }}
                className={'max-sm:w-full self-center'}
              >
                {btnText}
              </Button>
            </div>
          </Info>
        </div>
      </Container>
    </Section>
  );
};

CTABanner.displayName = 'CTA-Banner';

CTABanner.propTypes = {
  mods: PropTypes.object,
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ]).isRequired,
  subTitle: PropTypes.string,
  btnText: PropTypes.string,
  btnLink: PropTypes.string
};

export default CTABanner;
